import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetTypeSurveyConfig = (sociogramId, options = {}) => {
  const query = useApiQuery(
    ['typeSurveyConfig', sociogramId],
    'sociogram',
    `/type-survey-configs?sociograms=${sociogramId}`,
    {
      enabled: Boolean(sociogramId),
      ...options
    }
  )

  return {
    data: query.data ?? null,
    loading: query.isLoading || query.isFetching,
    error: query.isError ? query.error : null,
    getTypeSurveyConfig: query.refetch
  }
}
